import styled from '@emotion/styled';
import theme, { toRgba } from '../../theme';

const lineColor = toRgba(theme.colors.dark, theme.opacities.tableLines);

export const Container = styled.div({
  marginBottom: '1.875rem',
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    borderSpacing: 0,
    font: 'inherit',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  },
  'col.--first': {
    width: '50%',
  },
  'col.--first.--long': {
    width: '75%',
  },
  'col.--data': {
    width: '20ch',
  },
  'table, caption, tbody, tfoot, thead, tr, th, td': {
    margin: 0,
    padding: 0,
    border: 0,
    verticalAlign: 'baseline',
    textAlign: 'left',
  },
  'th, td': {
    padding: '0.625rem 0.25rem',
  },
  'tr.--spacer': {
    lineHeight: '1px',
    height: '0.625rem',
    '&.--s-level-0': {
      height: '3.75rem',
    },
    td: {
      padding: 0,
    },
  },
  'thead tr': {
    borderBottom: `1px solid ${lineColor}`,
  },
  'tbody tr.--line': {
    td: {
      borderTop: `1px solid ${lineColor}`,
      fontWeight: 'bold',
    },
  },
  'th.--right, td.--right': {
    textAlign: 'right',
  },
});

export const Row = styled.tr({
  '&.--level-0': {
    backgroundColor: toRgba(theme.colors.lightBlue, theme.opacities.tableHover),
  },
  '&.--level-1, &.--level-0': {
    fontWeight: 'bold',
  },

  '&.--marked': {
    backgroundColor: toRgba(theme.colors.lightGreen, theme.opacities.tableHover),
  },
});
